import { Component, OnInit, ViewEncapsulation, Input, HostBinding, ViewChild, ElementRef } from '@angular/core';
import { LeadsService } from '../../services/leads.service';
import { FormService } from '../../services/form.service';
import { CampaignService } from '../../services/campaign.service';

import { ActivatedRoute } from '@angular/router';
import { NgbDateStruct, NgbDateParserFormatter, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { DataExportService } from '../../shared/services/data-export.service';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { debounceTime, distinctUntilChanged, filter, tap } from 'rxjs/operators';

const equals = (one: NgbDateStruct, two: NgbDateStruct) =>
  one && two && two.year === one.year && two.month === one.month && two.day === one.day;

const before = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
    ? false : one.day < two.day : one.month < two.month : one.year < two.year;

const after = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
    ? false : one.day > two.day : one.month > two.month : one.year > two.year;

const now = new Date();

@Component({
  selector: 'app-leads',
  templateUrl: './leads.component.html',
  styleUrls: ['./leads.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class LeadsComponent implements OnInit {


  @ViewChild('searchBar') searchBar: ElementRef;
  public formId: string;
  public leads: any = [];
  public lead: any = {};
  public campaign: any = {};
  public startDate: any;
  public endDate: any = new Date();
  public filters = {
    type: "all",
    filter: "all",
    form_id: "",
    assigned: "",
    page: 0,
    startDate: "",
    endDate: "",
    reponseTime: "all",
    searchQuery: "",
  };
  public metrics: any = {
    call: 0, opportunity: 0, lost: 0, convert: 0, reponseTime: {
      reponseTime: { green: 0, yellow: 0, red: 0, OutOfTime: 0 }
    }
  };
  public responseTimesPercentages = {
    green: 0,
    yellow: 0,
    red: 0,
    outOfTime: 0,
  }

  public export: boolean = false;
  public loading: boolean = false;
  public page: number = 0;
  public totalDocs: number = 0;
  public commentBox: string = "commentBox";
  public errorModal: string = 'errorModal'
  public statusParams: any = {};
  public comment: any = { status: "", text: "" };
  public target: any;
  public leadComments: any = { call: "", opportunity: "", convert: "", lost: "" };
  public commentsModalId: string = "commentsModal";
  public rowsOnPage: number = 10;
  public filterQuery: string = "";
  public sortBy: string = "";
  public sortOrder: string = "desc";
  public rowsOnPageSet: number = 5;
  public modalId: string = "lead-info";
  public adminRole: boolean = false;
  public randomAssigment: boolean;
  public leadsColumns = { email: false, phone: false }
  public salesAssigned;
  public lastAttemp = '';

  form: any = {};
  fromDate: NgbDateStruct;
  toDate: NgbDateStruct;
  hoveredDate: NgbDateStruct;
  public userRole

  constructor(private leadsService: LeadsService, private route: ActivatedRoute,
    public parserFormatter: NgbDateParserFormatter, public calendar: NgbCalendar,
    private dataExport: DataExportService, private formService: FormService, private campaignService: CampaignService) {
    this.formId = this.route.snapshot.params.id;

    this.userRole = JSON.parse(localStorage.getItem('user')).data.role;
    if (this.userRole != 'sales') {
      this.export = true;
      this.adminRole = true;
    }
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
    this.filters.form_id = this.formId;
    this.endDate.setUTCHours(23, 59, 59, 999)
    this.endDate.toISOString()
    this.filters.endDate = this.endDate;
  }


  getMetrics() {
    this.leadsService.getMetrics({ form_id: this.formId, filter: this.filters })
      .subscribe((response: any) => {
        this.metrics.call = response.data[0].call.true || 0;
        this.metrics.opportunity = response.data[1].opportunity.true || 0;
        this.metrics.convert = response.data[2].convert.true || 0;
        this.metrics.lost = response.data[3].lost.true || 0;
        this.metrics.reponseTime = response.data[4]
        this.calculateResponseTimes();
      })
  }

  getSalesAssigned() {
    this.formService.getSalesAssigned({ form_id: this.formId })
      .subscribe((response: any) => {
        this.salesAssigned = response.names;
      });
  }

  getLeads() {
    return new Promise((resolve, reject) => {

      this.leadsService.getLeadsByPage(this.filters)
        .subscribe((response: any) => {
          // this.leads = response.data;
          // return response.data;
          setTimeout(resolve, 0, response.data);
        })
    });
  }

  getLeadsByPage(event: any = null) {
    this.loading = true;
    this.filters.page = event.page + 1;
    this.getMetrics();
    const params = this.filters;
    this.leadsService.getLeadsByPage(params)
      .subscribe((response: any) => {
        this.leads = response.data;
        this.leads[0].data.forEach(data => {
          if (data.name == 'correo' || data.name == 'email' || data.name == 'mail') {
            this.leadsColumns.email = true;
          } else if (data.name == 'numero_de_teléfono' || data.name == 'phone') {
            this.leadsColumns.phone = true;
          }
        })
        this.loading = false;
        this.page = response.page;
        this.totalDocs = response.totalDocs;
      })
  }

  getLeadsByFilter() {
    this.leadsService.getLeadsByFilter(this.filters)
      .subscribe((response: any) => {
        this.leads = response.data;
        this.loading = false;
        this.page = response.page;
        this.totalDocs = response.totalDocs;
      })
  }

  public rolePermitido: Boolean = false;

  setDisableLeadCheck(item: any, check: any) {
    if (this.userRole !== 'sales') {
      return false
    } else {
      switch (check) {
        case 'call':
          return item.call.status;

        case 'opportunity':
          if (item.call.status) {
            return item.opportunity.status;
          }
          return true;

        case 'lost':
          if (item.convert.status) {
            return true
          } else if (item.opportunity.status) {
            return item.lost.status;
          }
          return true;

        case 'convert':
          if (item.lost.status) {
            return true;
          } else if (item.opportunity.status) {
            return item.convert.status
          }
          return true;

        default:
          return false;
      }
    }
  }

  updateStatus(event: any, itemId: any, attempsArray?: any) {
    let target = event.target;
    let key = event.target.attributes["leadStatus"].nodeValue;
    this.statusParams = { lead_id: itemId }
    this.statusParams[key] = {
      date: new Date,
      status: target.checked,
      timeResquest: null
    }

    if (this.userRole === "admin" || this.userRole === "sales" || this.userRole === "manager") {
      this.rolePermitido = true
    }

    this.comment['status'] = key;

    if (this.rolePermitido) {
      if (key != 'convert') {
        this.updateLead(this.statusParams);

        // actualizar intentos de llamadas
        if (attempsArray !== undefined) {
          this.updateCallAttemps(attempsArray, itemId);
        }
        document.querySelector("#" + this.commentBox).classList.add('md-show');
      } else {
        this.updateLead(this.statusParams);
      }


    } else {
      document.querySelector("#" + this.errorModal).classList.add('md-show');
      target.checked = false
    }
  }

  updateLead(params: any) {
    this.leadsService.update(params)
      .subscribe((response: any) => {
        if (response.success === true) {
          this.getLeadsByPage({ page: this.page - 1 });
          for (let i in this.leads.data) {
            if (this.leads.data[i]._id === params.lead_id) {
              this.leads.data[i] = response.data;
            }
          }

        } else {
          console.log(response);
        }
      }, (error: any) => {
        console.log(error)
      });
  }

  updateCallAttemps(attempsArray: any, itemId: any) {
    attempsArray.push(new Date)
    let call_attemps_params = {};
    call_attemps_params = { lead_id: itemId };
    call_attemps_params['call_attemps'] = attempsArray;
    this.updateLead(call_attemps_params);

  }

  addComment() {
    let status = this.comment.status;
    this.statusParams[status].comment = this.comment.text;
    this.updateLead(this.statusParams);
    this.comment = {};
    document.querySelector("#" + this.commentBox).classList.remove('md-show');
  }

  // Date picker
  modelPopup: NgbDateStruct;
  modelDisabled: NgbDateStruct = {
    year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate()
  };

  isHovered = date => this.fromDate && !this.toDate && this.hoveredDate && after(date, this.fromDate) && before(date, this.hoveredDate);
  isInside = date => after(date, this.fromDate) && before(date, this.toDate);
  isFrom = date => equals(date, this.fromDate);
  isTo = date => equals(date, this.toDate);

  onDateChange(date: NgbDateStruct) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && after(date, this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  // Export data to excel
  async exportData() {
    this.filters.page = null;
    let leads = await this.getLeads();

    let decodedData = this.decodeData(leads);
    this.dataExport.exportAsExcelFile(decodedData, 'sample');
  }

  decodeData(data: any) {
    let decodedData = [];

    data.forEach(element => {
      let item = { status: "No gestionado" };

      Object.keys(element).map((key) => {
        if (key == "data") {
          for (let i = 0; i < element[key].length; i++) {
            let dataKey = element[key][i].name;
            item[dataKey] = element[key][i].values.toString();
          }
        } else {
          if (key !== "call" && key !== "opportunity" && key !== "convert" && key !== "lost" &&
            key !== "_id" && key !== "form_id" && key !== "__v" && key !== "assigment" && key !== "assigmentNames"
            && key !== "call_attemps") {
            if (key == "createdAt" || key == "updatedAt") {
              item[key] = new Date(element[key]).toLocaleDateString();
              item["Hora"] = new Date(element[key]).toLocaleTimeString();
            } else {
              item[key] = element[key];
            }
          } else {
            switch (key) {
              case 'assigmentNames':
                item['Asignados'] = element[key][0];
                break;
              case 'call_attemps':
                let elementsAmount = element[key].length;
                let lastAttemp = (element[key].length > 0) ? new Date(element[key].pop()).toLocaleString() : '';
                item['numero_de_intentos'] = elementsAmount;
                item['ultimo_intento_de_llamada'] = lastAttemp;
                break;
              case 'call':
                item['Llamado_comentario'] = element[key].comment;
                let called_date = (element[key].date !== null) ? new Date(element[key].date).toLocaleString() : '';
                item['Fecha_y_hora_llamado'] = called_date;
                break;
              case 'opportunity':
                item['Contactado_comentario'] = element[key].comment;
                let opportunity_date = (element[key].date !== null) ? new Date(element[key].date).toLocaleString() : '';
                item['Fecha_y_hora_contactado'] = opportunity_date;
                break;
              case 'lost':
                item['Perdido_comentario'] = element[key].comment;
                let lost_date = (element[key].date !== null) ? new Date(element[key].date).toLocaleString() : '';
                item['Fecha_y_hora_perdido'] = lost_date;
                break;
              case 'convert':
                let convert_date = (element[key].date !== null) ? new Date(element[key].date).toLocaleString() : '';
                item['Fecha_y_hora_vendido'] = convert_date;

              default:
                break;
            }
          }
        }
      })

      if (element["call"].status == true) {
        item.status = "Llamado";
        // item["callComment"] = element["call"].comment;
      } if (element["opportunity"].status == true) {
        item.status = "Contactado";
        // item["opportunityComment"] = element["opportunity"].comment;
      } if (element["convert"].status == true) {
        item.status = "Vendido";
      }

      decodedData.push(item);
    });

    return decodedData;
  }

  getInteractionInfo(item) {
    return item.user ? item.user.name + ' ' + new Date(item.date).toLocaleString() : '';
  }

  getLastAttempDate(attemptArray: any) {
    setTimeout(() => {
      this.lastAttemp = (attemptArray.length > 0) ? 'Último intento el ' + new Date(attemptArray.pop()).toLocaleString() : '';
    }, 500);
    return this.lastAttemp;
  }

  generateDateForLead(item) {
    return new Date(item.createdAt).toLocaleString();
  }

  generateTimeForLead(item) {
    return new Date(item.createdAt).toLocaleTimeString();
  }

  leadIsOnTime(item) {
    const dateTime = new Date(item.createdAt);
    const dayOfWeek = dateTime.getDay();
    const hour = dateTime.getHours();
    const minute = dateTime.getMinutes();
    const isBefore6pm = hour < 18 || (hour === 18 && minute === 0);
    const isAfter8am = hour > 7;
    const isWeekday = dayOfWeek >= 1 && dayOfWeek <= 5;
    return isBefore6pm && isAfter8am && isWeekday;
  }

  showComments(lead) {
    this.lead = lead;
    // this.leadComments.call = lead.call.comment;
    // this.leadComments.opportunity = lead.opportunity.comment;

    document.querySelector("#" + this.commentsModalId).classList.add('md-show');
  }

  setStartDate(date) {
    if (date) this.filters.startDate = new Date(date).toISOString();
    this.getLeadsByPage({ page: 0 });
  }
  setEndDate(date) {
    if (date) {
      let newDate = new Date(date);
      newDate.setUTCHours(23, 59, 59, 999);
      this.filters.endDate = newDate.toISOString();
    }
    this.getLeadsByPage({ page: 0 });
  }

  ngOnInit(): void {
    this.getMetrics();
    // this.getLeads();
    this.getSalesAssigned();
    this.getLeadsByPage({ page: this.page });

    this.formService.getForm(this.formId)
      .subscribe((response: any) => {
        this.form = response.data;
        this.randomAssigment = this.form.random_assignment;

        this.campaignService.getCampaign(this.form.campaign)
          .subscribe((response: any) => {
            this.campaign = response.data;
          });
      });

     // Wait 500ms after search. This for prevent saturate the server.
    fromEvent(this.searchBar.nativeElement, "keyup").pipe(
      filter(Boolean),
      debounceTime(500),
      distinctUntilChanged(),
      tap((htmlElement) => {
        // The query string is already in filters.searchQuery via ngModel.
        this.getLeadsByPage({ page: 0 })
      })
    ).subscribe()


    //this.campaign = JSON.parse(localStorage.getItem('campaign'));
  }

  openMyModal(event, item) {
    document.querySelector("#" + this.modalId).classList.add('md-show');
    let valorShow: any = []
    let objecTmp: any = {}
    if (this.form.fields.length > 0) {


      for (let dato in item.data) {
        for (let valores in this.form.fields) {
          if (item.data[dato].name == this.form.fields[valores].name) {
            objecTmp = this.form.fields[valores]
            objecTmp.values = item.data[dato].values
            valorShow.push(objecTmp)
            break;
          }
        }
      }
      this.lead = valorShow;
    } else {
      for (let i in item.data) {
        item.data[i].displayName = item.data[i].name
      }
      item.data.displayName = item.data.name
      this.lead = item.data
    }
  }

  closeMyModal(event, item) {
    document.querySelector("#" + item).classList.remove('md-show');
  }

  TimeRequest(time: any) {
    let strTime: string;
    let resuTime: number;
    if (time == 1) {
      strTime = time + " minuto"
    } else {
      strTime = time + " minutos"
    }

    if (time > 60 && time < 1440) {
      resuTime = Math.round(time / 60);

      if (resuTime == 1) {
        strTime = resuTime + " hora";
      }
      else {
        strTime = resuTime + " horas";
      }

    }
    else if (time > 1440) {
      resuTime = Math.round((time / 60) / 24);

      if (resuTime == 1) {
        strTime = resuTime + " día";
      } else {
        strTime = resuTime + " días";
      }

    }
    return strTime;

  }

  private calculateResponseTimes(){
    const {green, yellow, red, OutOfTime} = this.metrics.reponseTime.reponseTime;
    const total = this.totalDocs;
    const calculatePercentage = (value:number): number => {
      return +(((value * 100) / total).toFixed(2));
    }

    const result = {
      green: calculatePercentage(green),
      yellow: calculatePercentage(yellow),
      red: calculatePercentage(red),
      outOfTime: calculatePercentage(OutOfTime),
    }
    this.responseTimesPercentages = result;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/leads/leads.component.ts